/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Norwegian (Norway): no-no
 */

/**
 * Translation file for no-NO locale
 *
 * @file no.js
 * @author Mohamed yasar arabath M
 */

const no = {
  'popularChannelSlider.allChannels': 'Alle kanaler',
  'popularChannelSlider.recommended': 'Anbefalt',
  'hero.myetextbook.link': 'bibliotek',
  'hero.myetextbook.text': 'Ikke rett tittel? Gå til eLærebok din',
  'hero.etextfeaturestitle': 'Finn læremateriell i eLæreboken din',
  'hero.etextfeaturesdescription': 'eLæreboken kommer med læremateriell designet for å hjelpe deg med å lykkes. Studer med flashkort og mer, rett fra eLæreboken.',
  'aichat.title1': 'Få KI-drevet hjelp om hva som helst relatert til denne eLæreboken.',
  'aichat.chatDesc1': 'Skriv inn et spørsmål for å komme i gang',
  'subscriptiontext.isSubscribed': 'En del av abonnementet',
  'subscriptiontext.nonSubscriber': 'Oppgrader til dull tilgang',
  'topicConatiner.otherHeader': 'Relaterte videoer og øving',
  'topicConatiner.exactLiteHeader': 'Relaterte konsepter og øving',
  'moremenu.downloadApp': 'Last ned appen',
  'moremenu.downloadAppAlreadyDownload': '%Click here% for å laste ned appen på en annen enhet og logge inn automatisk, eller bruk den unike QR-koden til å logge sikkert inn på appen du allerede har installert.',
  'moremenu.downloadAppNotDownload': '%Click here% for å laste ned appen og logge inn sikkert med den unike QR-koden din',
  'channel.noBundletitle': 'Bruk studieforberedelser for relaterte og andre fag',
  'onboard.studyPlan': 'En tilpasset studieplan ble opprettet!',
  'onboard.addCourseAnother': 'Vil du legge til et annet fag?',
  'onboard.purchase': 'Jeg må kjøpe en eLærebok fra Pearson',
  'onboard.addCourseWithoutEtext': 'Legg til fag med studieforberedelser',
  'onboard.mayBeLater': 'Kanskje senere',
  'onboard.aboutCourse': 'Fortell oss om kurset ditt',
  'onboard.close': 'Lukk',
  'course.addTitle': 'Legg til fag',
  'common.PURCHASE': 'Kjøp',
  'common.CLOSE': 'Lukk',
  'open': 'åpen',
  'continue': 'Fortsett',
  'yes': 'Ja',
  'no': 'Nei',
  'audio': 'Lyd',
  'courses.toc.PUBLISH_SUCCESS': 'Supert!',
  'courses.toc.PUBLISH_MESSAGE': 'Studentene ser endringene dine hver gang de åpner innholdet.',
  'errors.GENERIC_TITLE': 'Du har ikke tilgang akkurat nå',
  'errors.GENERIC_DESC': 'Først, oppdater eller tøm hurtigminne. Hvis det ikke virker, kan du kontakte Pearsons ',
  'errors.GENERIC_LINK': 'kundestøtte',
  'errors.GENERIC_CODE': 'Feilkode: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Fant ikke noe abonnement',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Kontoen din har ikke tilgang til denne tittelen. Hvis du mener at du mottok denne meldingen med en feil, kan du ta kontakt med Pearsons tekniske kundestøtte',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Fant ikke noe abonnement',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Abonnementet ditt inkluderer ikke tilgang til eLæreboken, men du kan abonnere på den nå med et kredittkort.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Min konto',
  'menu.helpCenter': 'Hjelpesenter',
  'menu.preferencesCenter': 'Preferansesenter',
  'menu.CONTACT_SUPPORT': 'Ta kontakt med kundestøtte',
  'menu.HELP_SUPPORT': 'Hjelp og støtte',
  'menu.FAQS': 'Vanlige spørsmål',
  'menu.CHAT_WITH_SUPPORT': 'Chat med kundestøtte',
  'menu.OTP_CODES': 'Engangskoder',
  'menu.LAUNCH_CODE': 'Startkodelogg',
  'menu.SEND_CODE': 'Send brukeren en ny kode på e-post',
  'menu.SEND_CODE_PHONE': 'Send brukeren en ny kode på SMS',
  'menu.LEGAL': 'Juridisk',
  'menu.PRIVACY_NOTICE': 'Personvernerklæring',
  'menu.TITLE_INFO': 'Tittelinformasjon',
  'menu.PEARSON_ACCESSIBILITY': 'Tilgjengelighet hos Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registrer {deviceLimit} enheter. Bytt ut én i måneden.',
  'menu.ACCESSIBILITY': 'Tilgjengelighet',
  'menu.ACCESSIBILITY_SUPPORT': 'Tilgjengelighetsstøtte',
  'menu.DEVICES': 'Nylige enheter',
  'menu.THIS_DEVICE': 'Denne enheten',
  'menu.GET_THE_APP_DOWNLOAD': 'Last ned mobilappen',
  'menu.MOJO_APP_INFO': 'Gå til App Store på telefonen eller nettbrettet ditt for å bruke Pearson+ offline.',
  'menu.DEVICE_LABEL': 'Enhet',
  'menu.DEVICE_DISCONNECT': 'Frakoblet',
  'menu.FOXIT': 'Drevet av FoxIT',
  'menu.TERMS_OF_USE': 'Brukervilkår',
  'menu.SIGN_OUT': 'Logg ut',
  'menu.PRINT_PAGE': 'Skriv ut side',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Skrevet ut av {fullName}({email}) den {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Du har allerede byttet denne måneden',
  'device.SWITCH_DEVICE': 'Vil du bytte til nåværende enhet?',
  'device.SWITCH_ONCE': 'Siden du bare kan bytte én gang i måneden, vil du ikke kunne angre på dette.',
  'device.SEAT_TAKEN': 'Den plassen er opptatt',
  'device.DISCONNECT_DEVICE': 'Du kan bare logge inn på tre enheter. For å fortsette her må du logge ut fra en annen enhet.',
  'device.ALERT_TEXT': 'Husk at du bare kan bytte enhet én gang i måneden.',
  'device.DISCONNECT': 'Frakoblet',
  'device.CONTINUE': 'Fortsett',
  'device.HEADER': 'Vil du avslutte den andre nettleserøkten?',
  'device.CLOSE': 'Tilbake til startsiden',
  'device.CODE': 'Fortsett her ved å skrive inn autentiseringskoden vi sendte til {maskedEmail}. Virker det ikke? Sjekk søppelpostkassen, {email}, eller ta kontakt med {support}.',
  'device.TIMER': 'Du har {time} på deg til å skrive inn koden her',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Vanlige spørsmål',
  'device.RESEND_NAME': 'Send på nytt',
  'device.NOTE': 'Hvis du ofte bruker Pearson+ på to steder, som på jobb og hjemme, må du huske å logge ut når du er ferdig. Du kan også bruke mobilappen for Pearson+ på opptil to enheter. Se {faq} for mer informasjon.',
  'device.NOTE_HEADER': 'Unngå dette neste gang',
  'device.CONTACT_SUPPORT': 'kundestøtte',
  'device.CONTACT_EMAIL': 'oppdater e-posten din',
  'device.INCORRECT': 'Feil – dobbeltsjekk koden eller send den på nytt.',
  'device.MANY_ATTEMPTS': 'For mange forsøk. Prøv å sende koden på nytt',
  'device.EXPIRED': 'Tiden har gått ut. Prøv å sende koden på nytt',
  'device.ACCESS_HEADER': 'Du er inne!',
  'device.ACCESS_DESC': 'Økten din ble autentisert. Vil du oppdatere passordet ditt når du først er i gang?',
  'device.ACCESS_CHANGE_PASSWORD': 'Endre passord',
  'device.ACCESS_RESET_PASSWORD': 'Tilbakestill passord',
  'device.THREATONE_TITLE': 'Er alt i orden?',
  'device.THREATONE_DESC': 'Vi har lagt merke til mistenkelig aktivitet på kontoen din.',
  'device.THREATONE_DESC_TWO': 'Det er lurt å bytte passord.',
  'device.MAY_BE_LATER': 'Kanskje senere',
  'device.OKAY': 'Ok',
  'device.ACCOUNT_LOCK_DESC': 'Vi logger deg ut for å holde kontoen sikker. Vi har sendt en lenke til å tilbakestille passordet ditt til e-posten som er knyttet til kontoen din.',
  'device.ACCOUNT_LOCK_TITLE': 'Vi har lagt merke til mistenkelig aktivitet på kontoen din',
  'device.ACCOUNT_LOCK_TIMER': 'Du blir logget ut om {time}',
  'navigation.PAGE': 'Side',
  'launchcode.CREATEBY': 'Opprettet av:',
  'launchcode.sentvia': 'Sendt via:',
  'launchcode.CODEINLAST': 'Koder de siste 7 dagene:',
  'launchcode.TIMESENT': 'Sendetid: ',
  'launchcode.ACCOUNTEMAIL': 'Konto-e-post:',
  'launchcode.LAUNCHDIALOGTITLE': 'Engangskodelogg',
  'textmessage.TITLE': 'Skriv inn telefonnummer',
  'textmessage.PHONE_NUMBER': 'Telefonnummer',
  'textmessage.SEND_CODE': 'Send kode',
  'textmessage.INVALID_NUMBER': 'Ugyldig mobilnummer.',
  'textmessage.SUCCESS_MESSAGE': 'Koden er sendt',
  'remove.title': 'Vil du fjerne tittelen?',
  'remove.subTitle': 'Du kan alltids hente den tilbake senere – bare bruk søket for å legge den til igjen.',
  'remove.buttonText': 'Fjern',
  'search.searchPlaceHolderPPlus': 'Søk etter ISBN, tittel eller forfatter',
  'search.searchPlaceHolderEText': 'Søk i biblioteket ditt',
  'footer.downloadMobileApp': 'Last ned mobilappen',
  'footer.termsOfUse': 'Brukervilkår',
  'footer.privacy': 'Personvern',
  'footer.cookies': 'Informasjonskapsler',
  'footer.doNotSellMyPersonalInformation': 'Ikke selg personopplysningene mine',
  'footer.accessibility': 'Tilgjengelighet',
  'footer.patentNotice': 'Patenterklæring',
  'footer.copyrights': 'Pearson, med enerett.',
  'hero.toc.defaultPlacehoder': '– velg et emne –',
  'hero.openEtextBookV1': 'Åpne eLærebok',
  'hero.heroHeading': 'Fordi du studerer <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Studieforberedelser',
  'hero.study.help': 'Få studiehjelp',
  'hero.study.jumpBackIn': 'Hopp inn igjen',
  'hero.study.numOfUsers': 'Akkurat nå bruker <b>{num_of_users}</b> studenter Kanaler.',
  'hero.heroChannel.cardsHeading': 'Fortsett der du slapp',
  'hero.marketingcard1.copy.title': 'Lær med videoer',
  'hero.marketingcard1.copy.description': 'Se små, raske videoer som forklarer vanskelige emner.',
  'hero.marketingcard2.copy.title': 'Øvingsproblemer',
  'hero.marketingcard2.copy.description': 'Gjør deg klar for eksamen med tusenvis av eksamen-lignende spørsmål og løsninger.',
  'hero.marketingcard3.copy.title': 'Få hjelp fra erfarne veiledere',
  'hero.marketingcard3.copy.description': 'Legg ut spørsmål og få svar fra fageksperter.',
  'hero.popularTopics.heading': 'Andre populære emner i denne kanalen',
  'hero.popularChannels.headingv1': 'Tar du et annet fag?',
  'hero.popularChannels.descriptionv2': 'Bla gjennom populære emner for studiehjelp.',
  'hero.practice': 'Øv',
  'hero.herobook.mappedChannelHeading': 'Anbefalt studiehjelp i denne kanalen',
  'libraryL2.myBooks': 'Mine bøker',
  'libraryL2.archived': 'Arkivert',
  'libraryL2.back': 'Tilbake',
  'hero.practiceProblem': 'Øvingsproblem',
  'nativeAppBanner.drawer.title': 'Åpne i …',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+-appen',
  'nativeAppBanner.banner.title': 'Pearson+-appen',
  'nativeAppBanner.banner.description': 'Lær i farta',
  'hero.promotionalcard.list1': 'Små, raske videoer som forklarer vanskelige emner',
  'hero.promotionalcard.list2': 'Tusenvis av eksamen-lignende spørsmål',
  'hero.promotionalcard.list3': 'Få svar fra fageksperter',
  'hero.studyandexamprep': 'Studieforberedelser',
  'hero.heroBook.sectionSubHeadingV1': 'Bli ekspert på vanskelige emner med videoforklaringer og øvingsspørsmål som er skreddersydd til fagene dine.',
  'hero.heroBook.sectionSubHeadingV2': 'Bli ekspert på vanskelige emner med forklaringer av konsepter og øvingsspørsmål som er skreddersydd til fagene dine.',
  'hero.SeeAllStudyOptions': 'Se alle studiealternativer',
  'hero.herobook.mappedChannelHeadingV1': 'Anbefalte videoer og øvingsspørsmål',
  'hero.popularTopics.headingV1': 'Andre populære emner',
  'hero.heroHeadingV1': 'For <span>{replace_value}</span>',
  'hero.learnmore': 'Finn ut mer',
  'hero.eTextbook': 'eLærebok',
  'hero.goToPage.label': 'Gå til side',
  'subscription.studyTitle': 'Studieforberedelser',
  'print.printAvailTitle': 'Vil du skrive ut denne siden? Sånn gjør du det',
  'print.printAvailDesc': 'Velg kontoikonet fra øverste høyre hjørne i eLæreboken. Velg «Skriv ut side» fra alternativene og velg utskriftsinnstillinger.',
  'print.printNotAvailTitle': 'Utskriftsalternativet for denne eTeksten er ikke aktivert.',
  'print.printNotAvailDesc': 'For praktisk tilgang uten internett kan du laste ned titlene via mobilappen for Pearson+ og nyte fleksibel læring når og hvor som helst!',
  'hero.header.cta': 'Gå til studieverktøy',
  'hero.header.ctav2': 'Åpne Studieforberedelser',
  'hero.marketing.title': 'Finn eLæreboken din',
  'hero.marketing.subTitle': 'Velg mellom over 2000 eLærebøker med lyd, flashkort, notater og mer. Bare 10,99 USD i måneden for et firemåneders semester.',
  'hero.popularchannels.desc': 'Få studiehjelp med disse populære emnene',
  'hero.removecourse.title': 'Vil du fjerne faget fra dashbordet?',
  'hero.removecourse.description': 'Du kan alltids legge til faget på dashbordet igjen ved å klikke på «Legg til fag»',
  'hero.removecourse.primaryCtaText': 'Fjern',
  'hero.removecourse.secondaryCtaText': 'Avbryt',
  'hero.tableOfContents': 'Innholdsfortegnelse',
  'hero.search': 'Søk',
  'hero.emptystate.cta': 'Søk i eLærebøker',
  'hero.watch_it_again': 'Se den igjen',
  'hero.mondly.learnLang.title': 'Lær et nytt språk gratis',
  'hero.mondly.subTitle': 'Pearson+ eLærebok-brukere får tre måneder Mondly fra Pearson med på kjøpet.',
  'hero.mondly.description': 'De fleste språklæringsappene lar deg bare lære fra engelsk. Men det er best å lære fra ditt eget morsmål, så Mondly lar deg lære fra alle de <strong>41 språkene våre</strong>.',
  'hero.mondly.startLearningCTA': 'Begynn å lære',
  'hero.mondly.marketing.bestApp': 'Best App',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'App of the Year',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart – 2017 EMEA Winner',
  'hero.mondly.marketing.editorChoice': 'Editor Choice',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Lær et språk',
  'header.menu.moreAtPearson': 'Mer hos Pearson',
  'hero.subscriptionStatusTitle2': 'Pearson+-ressursene dine',
  'hero.startStudying': 'Begynn å studere',
  'onboard.studyMaterials': 'Velg et emne, så lager vi et dashbord med tilpasset læremateriell.',
  'hero.myETextbooks': 'Mine eLærebøker',
  'header.continueInTheApp': 'Fortsett i appen',
  'hero.learnTxt': 'Lær',
  'hero.examPrepTxt': 'Eksamensforberedelser',
  'hero.aITutorTxt': 'KI-veileder',
  'AI.toolTip': 'Spør meg om hva som helst i eLæreboken',
  'hero.studyExamPrepAllYourCourses': 'Studieforberedelser for alle fagene dine',
  'header.qrCode.subHeaderTxt': 'Bruk denne QR-koden for å logge inn på Pearson+-appen raskt og trygt på mobilenheten din.',
  'header.qrCode.dontHaveApp': 'Har du ikke appen?',
  'header.qrCode.footerTxt': 'Skann denne koden for å bli omdirigert til App Store eller Google Play. Når appen er lastet ned, kan du skanne den igjen for å logge inn.',
  'header.qrCode.errorMsg': 'QR-koden lastet ikke. Lukk og prøv igjen.',
  'hero.yourETextbook': 'Din eLærebok',
  'onboard.addCourseWithEtextBundle': 'Legg til fag med studieforberedelser',
  'onboard.disableTooltipText': 'Alle kurs med studieforberedelser er lagt til!',
  'subscriptionstatus.bundlecta': 'Gå til studieforberedelser',
  'subscriptionstatus.nonbundlecta': 'Gå til studieforberedelser',
  'channel.genericBundle': 'Bruk studieforberedelser som hjelp til de andre fagene dine',
  'channel.relatedBundle': 'Du kan også bruke studieforberedelser som hjelp til de andre fagene dine',
  'onboard.courseAdded': 'Kurset ble lagt til!',
  'hero.flashcards': 'Flashkort',
  'relatedChannelCard.title': 'Lær mer med denne relaterte kilden',
  'relatedChannelCard.badgeText': 'Relaterte studieforberedelser',
  'sessionInactivity.title': 'Er du her fortsatt?',
  'sessionInactivity.description': 'Økten din går ut om <b>%TIMER%</b> på grunn av inaktivitet<br/>. Vil du holde deg pålogget?',
  'sessionInactivity.keepMeSignIn': 'Hold meg pålogget',
  'sessionInactivity.signOut': 'Logg ut',
  'sessionTimeout.title': 'Økten ble tidsavbrutt',
  'sessionTimeout.description': 'Økten ble tidsavbrutt på grunn av inaktivitet.',
  'print.qrCode.header': 'Bruk denne QR-koden for å åpne Pearson+-appen på mobilenheten din.',
  'print.qrCode.footer': 'Skann denne koden for å bli omdirigert til App Store eller Google Play. Når appen er installert, kan du logge inn for å laste ned og lese titlene dine.',
  'hero.nestest.title': 'Gjør deg klar for eksamen for å bli sertifisert lærer',
  'hero.nestest.subTitle': 'Brukere av Pearson+ har nå tilgang til nasjonalt tilpassede forberedelseskurs og øvelsesprøver for å forberede seg på eksamenene for å bli sertifisert lærer.',
  'hero.channelAI.title': 'Trenger du hjelp? KI-veilederen er her for deg.',
  'hero.channelAI.desc': 'Still et spørsmål og få detaljert leksehjelp, leseanbefalinger og mer – personlig hjelp når du måtte trenge det.',
  'hero.channelAI.action': 'Spør KI-veilederen nå',
  'new': 'Nyhet!',
  'hero.practice.numOfUsers': 'Denne delen har <b>{practice_num_of_users}</b> øvingsproblemer.',
  'hero.practice.cta': 'Øv nå',
  'hero.practice.title': 'Øvingsproblem',
  'diagnostics.errorMsg': 'Diagnostikken ble ikke lastet inn. Lukk og prøv igjen',
  'qrcode.title': 'Begynn å studere hvor som helst',
  'qrcode.subtitle': 'Lær hvor som helst og når som helst med mobilappen for Pearson+. Last den ned nå og få tilgang til en sømløs læreopplevelse.',
  'qrcode.detailsv1': 'Med Pearson+-appen kan du bruke denne QR-koden til å fortsette der du slapp. Søk i boken, studer med flashkort, se videoleksjoner og mer, hvor enn du drar.',
  'qrcode.detailsv2': 'Skann denne QR-koden når du vil logge inn raskt og fortsette der du slapp.',
  'qrcode.details': 'Med Pearson+-appen kan du bruke denne QR-koden til å fortsette der du slapp.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Lær hvor som helst og når som helst med mobilappen for Pearson+. Last den ned nå og få tilgang til en sømløs læreopplevelse.',
  'install': 'Install',
  'header.menu.createCourse': 'Nytt fag',
  'header.dropdown.courses': 'Fag',
  'header.dropdown.recentlyViewed': 'Nylig sett',
  'header.dropdown.viewAll': 'Se alle fag',
  'aet.courseHeader.inviteStudents': 'Inviter studenter',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Inviter studenter til å få tilgang til denne eLæreboken ved å kopiere lenken eller instruksjonene under i e-posten eller leselisten din.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Lenke',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Kopier lenke',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instruksjoner med lenke',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Kopier instruksjoner',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Du blir bedt om å logge inn med den eksisterende Pearson-kontoen din. Hvis du ikke har en Pearson-konto, kan du lage en.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Startdato:',
  'aet.courseHeader.endDate': 'Sluttdato:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Administrer studentliste',
  'aet.home.managegradesync': 'Administrer karaktersynkronisering',
  'aet.home.copycourse': 'Kopier fag',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Nåværende',
  'aet.instructorCourse.tabs.past': 'Forbi',
  'aet.instructorCourse.tabs.courseSettings': 'Kursinnstillinger',
  'aet.instructorCourse.tabs.manageRoster': 'Administrer studentliste',
  'aet.instructorCourse.currentCourses.title': 'Nåværende fag',
  'aet.instructorCourse.pastCourses.title': 'Tidligere fag',
  'aet.instructorCourse.createOrCopy.title': 'Opprett eller kopier fag',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Kopier faget til en annen lærer eller opprett et nytt',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Kopier faget til en annen lærer',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Skriv inn fag-ID-en for å finne faget du vil kopiere.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Fag-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Skriv inn fag-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Du søkte etter',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Opprett et nytt fag fra katalogen',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Søk etter tittel, forfatter, ISBN eller nøkkelord.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Søk …',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Vis mer',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Vis mindre',
  'aet.instructorCourse.cancel': 'Avbryt',
  'aet.instructorCourse.loading': 'Laster inn …',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Karaktersynkronisering',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Administrer karaktersynkronisering',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Navn på fag',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Uten navn',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Navn på del',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Uten navn',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institusjon',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institusjon kreves',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Noe gikk galt. Prøv igjen.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Fant ingen resultater',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Fagets startdato',
  'aet.instructorCourse.courseForm.endDateLabel': 'Fagets sluttdato',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/åå',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'La andre kopiere dette faget',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Del denne koden med lærerne som vil kopiere dette faget',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kopier kode',
  'aet.instructorCourse.courseForm.optionalSuffix': '(valgfritt)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Skjemaet har valideringsfeil',
  'aet.instructorCourse.courseForm.submitContinue': 'Fortsett',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Lagrer …',
  'aet.instructorCourse.courseForm.submitError': 'Vi kunne ikke opprette faget ditt. Prøv igjen.',
  'aet.instructorCourse.courseForm.submitEditError': 'Vi kunne ikke lagre endringene dine. Prøv igjen.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Lagre endringer',
  'aet.instructorCourse.courseForm.materialsHeader': 'Kursmateriell',
  'aet.instructorCourse.courseForm.resolveError': 'Vi kunne ikke laste inn kursmateriell Prøv igjen.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Sist sett',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Nylig lagt til',
  'aet.instructorCourse.coursesSort.aToZ': 'A til Å',
  'aet.instructorCourse.coursesSort.zToA': 'Å til A',
  'aet.instructorCourse.manageRoster.column.name': 'Navn',
  'aet.instructorCourse.manageRoster.column.role': 'Rolle',
  'aet.instructorCourse.manageRoster.column.email': 'E-post',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'Lærer',
  'aet.instructorCourse.roster.status.active': 'Aktiv',
  'aet.instructorCourse.roster.status.inactive': 'Inaktiv',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Alle medlemmer',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktive studenter',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inaktive studenter',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Lærerassistent',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Lærer',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Forfatter:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Dato faget ble opprettet:',
  'aet.instructorCourse.noCoursesFound': 'Fant ingen fag',
  'aet.instructorCourse.backButton': 'Tilbake',
  'aet.instructorCourse.selectCourse': 'Velg fag',
  'aet.home.linkedToLms': 'Koblet til LMS',
  'aet.instructorCourse.courseForm.title.create': 'Opprett fag',
  'aet.instructorCourse.courseForm.title.copy': 'Kopier fag',
  'aet.instructorCourse.courseForm.title.edit': 'Faginformasjon',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Oppgaver',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Oppgaveinnhold',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Oppgavefrister',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Markeringer og notater',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Markeringsfarge',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Notattekst',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Delt status',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Studentliste og engasjement',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Studentnavn',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'E-postadresser',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Påmeldinger',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Fullførelse og innsikt',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Innstillinger',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Kopierte data',
  'aet.studentRoster.manageStudentRosterButton': 'Administrer studentliste',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Eksporter studentfremgang',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Påmeldt:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rolle:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Som lærerassistent kan denne personen se fremgangen og resultatene til alle studentene i klassen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'De kan også administrere studenter og oppgaver, men de kan ikke slette klassen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Forfrem til lærerassistent',
  'aet.home.manageRoster.searchPlaceholder': 'Søk etter student',
  'aet.home.manageRoster.inactivateButtonLabel': 'Gjør valgte studenter inaktive',
  'aet.home.manageRoster.FilterLabel': 'Vis',
  'aet.home.manageRoster.updatingMessage': 'Oppdaterer studentliste … Dette kan ta noen minutter.',
  'aet.home.courses.search.searchPlaceHolder': 'Søk etter fag',
  'aet.courses.emptyStateDescription': 'Begynn å sette sammen faget ved å velge et alternativ nedenfor.',
  'nativePromoBanner.continueInBrowser': 'Fortsett i nettleser',
  'globalnav.tooltip.hideNavText': 'Skjul navigasjon',
  'globalnav.tooltip.showNavText': 'Vis navigasjon',
  'aet.syllabus.progressTitle': 'Henter ut …',
  'aet.syllabus.progressDesc': 'Vent mens vi behandler leselisten din.',
  'aet.syllabus.uploadInputLabel': 'Dra og slipp filer, eller klikk for å laste opp',
  'aet.syllabus.uploadSyllabusTabLabel': 'Last opp leseliste',
  'aet.syllabus.dateAdjusterTabLabel': 'Datojustering',
  'aet.syllabus.addManuallyTabLabel': 'Legg til manuelt',
  'aet.syllabus.addEditLaterText': 'Du kan alltids legge til og redigere oppgaver senere',
  'aet.syllabus.editAssignmentLabel': 'Rediger oppgave',
  'aet.syllabus.addAssignmentLabel': 'Legg til oppgave',
  'aet.syllabus.assignmentTitleLabel': 'Oppgavetittel',
  'aet.syllabus.dueDateLabel': 'Frist',
  'aet.syllabus.editDueDateLabel': 'Rediger frist',
  'aet.syllabus.chaptersCoveredLabel': 'Velg kapitlene eller delene som skal dekkes.',
  'aet.syllabus.updateCtaLabel': 'Oppdater oppgave',
  'aet.syllabus.addCtaLabel': 'Legg til oppgave',
  'aet.syllabus.uploadLabel': 'Last opp',
  'aet.syllabus.confirmLabel': 'Bekreft',
  'aet.syllabus.updateDatesLabel': 'Oppdater dato',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Slette oppgave?',
  'aet.deleteAssignmentTitleMultiple': 'Slett oppgavene?',
  'aet.deleteAssignmentWarning': 'Denne handlingen kan ikke angres, og alle tilknyttede innsendinger og studentdata vil ikke lenger være synlige.',
  'aet.deleteAssignmentKeepCTA': 'Behold oppgave',
  'aet.deleteAssignmentDeleteCTA': 'Slett',
  'aet.assignments.loadingAsset': 'Laster inn ressurs …',
  'aet.assignments.allCaughtUpDescription': 'Ingen oppgaver med frist denne uken.',
  'aet.assignments.progressTitle': 'Fremgang',
  'aet.assignments.performanceTitle': 'Selvsikkerhet',
  'aet.assignments.completionTitle': 'Fullførelse',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Legg til oppgave',
  'aet.assignments.deleteTooltip': 'Slett valgte oppgaver',
  'aet.assignments.selectToDeleteLabel': 'Velg og slett-modus',
  'aet.assignments.bulkEditTooltip': 'Rediger flere oppgaver',
  'aet.assignments.title': 'Oppgaver',
  'aet.assignments.assignmentTitle': 'Oppgave',
  'aet.assignments.dueDate': 'Frist',
  'aet.tabular.searchPlaceholder.assignments': 'Søk etter oppgaver',
  'aet.tabular.searchPlaceholder.students': 'Søk etter studenter',
  'aet.tabular.searchPlaceholder.questions': 'Søk etter spørsmål',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Én eller flere studenter har forlenget fristen for alle oppgavene',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Én eller flere studenter har forlenget fristen for denne oppgaven',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Én eller flere studenter har fått forlenget fristen. Se etter Info-ikonet for å identifisere disse oppgavene.',
  'aet.home.loading': 'Laster inn …',
  'aet.home.errorFetchingAssignments': 'Det oppsto en feil under henting av oppgaver',
  'aet.home.dueThisWeekTitle': 'Frist denne uken',
  'aet.home.allCaughtUpTitle': 'Du er oppdatert!',
  'aet.home.allCaughtUpDescription': 'Ingen oppgaver med frist denne uken.',
  'aet.home.suggestedRemediationTitle': 'Foreslått gjennomgang av Studieforberedelser',
  'aet.home.noSuggestedRemediationTitle': 'Materiell med ingen foreslått gjennomgang',
  'aet.home.noSuggestedRemediationDescription': 'Sjekk igjen etter neste oppgave.',
  'aet.home.assignmentIncludesTitle': 'Oppgaven inkluderer',
  'aet.home.sectionsLabel': 'Kapitler',
  'aet.home.questionsCount': '{count} spørsmål',
  'aet.home.dueLabel': 'Frist: {dueDate}',
  'aet.home.due': 'Frist:',
  'aet.home.progressCompletedLabel': 'Fullført',
  'aet.home.progressCompletedPastDueLabel': 'Fullfør etter frist',
  'aet.home.progressInProgressLabel': 'Pågår',
  'aet.home.progressNotStartedLabel': 'Ikke påbegynt',
  'aet.home.progressCountOfTotal': '{count} av {total}',
  'aet.home.NotAttemptedLabel': 'Ikke forsøkt',
  'aet.home.questionsTotalLabel': 'Totalt antall spørsmål',
  'aet.home.progressCompletedOnTimeLabel': 'Ferdig i tide',
  'aet.home.segmentGreatLabel': 'Supert',
  'aet.home.segmentGettingThereLabel': 'Ok',
  'aet.home.segmentNeedsReviewLabel': 'Trenger litt til',
  'aet.home.segmentOkayLabel': 'Ok',
  'aet.home.editAssignmentTooltip': 'Rediger oppgave',
  'aet.home.deleteAssignmentTooltip': 'Slett oppgave',
  'aet.home.viewDetailsButton': 'Se detaljer',
  'aet.home.viewAsStudentButton': 'Se som student',
  'aet.home.welcomeButtonText': 'Kom i gang →',
  'aet.review.emptyStateTitle': 'Ingenting å repetere',
  'aet.review.emptyStateDescription': 'Sjekk igjen etter neste oppgave.',
  'aet.dashboard.tabs.upNext': 'Neste',
  'aet.dashboard.tabs.welcome': 'Velkommen',
  'aet.dashboard.tabs.assignments': 'Oppgaver',
  'aet.dashboard.tabs.review': 'Gå gjennom',
  'aet.dashboard.tabs.studentRoster': 'Studenter',
  'aet.dashboard.classSchedule': 'Timeplan:',
  'aet.syllabus.dueTimeLabel': 'Frist for innlevering',
  'hero.accessEducatorGuides': 'Finn veiledning for lærere',
  'aet.assignment.save': 'Lagre',
  'aet.assignment.saveAndAdd': 'Lagre og legg til en annen',
  'aet.assignment.delete': 'Slett',
  'aet.assignment.saveAndClose': 'Lagre og lukk',
  'aet.studentRoster.title': 'Studenter',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Frister',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 dager',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 dager',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 dager',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 uke',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 uker',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Siste undervisningsdag',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} oppgaver er oppdatert',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Oppgaver med utgått frist kunne ikke oppdateres automatisk. Rediger hver av dem og angi en ny frist.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Kunne ikke oppdatere frister',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Fristen er utgått for alle oppgavene, og de kunne ikke oppdateres automatisk. Rediger hver av dem og angi en ny frist.',
  'aet.bulkEdit.bulkSplitInstruction': 'Vi deler opp oppgavene dine jevnt.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Frist for første oppgave',
  'aet.bulkEdit.lastAssignmentDue': 'Frist for siste oppgave',
  'aet.bulkEdit.assignmentsDueDays': 'Hvilke dager vil du at oppgavene skal ha frist?',
  'aet.bulkEdit.addEditLaterText': 'Vi bruker KI til å lage oppgaver. Du kan når som helst legge til og redigere oppgaver senere.',
  'aet.bulkEdit.monday': 'Mandag',
  'aet.bulkEdit.tuesday': 'Tirsdag',
  'aet.bulkEdit.wednesday': 'Onsdag',
  'aet.bulkEdit.thursday': 'Torsdag',
  'aet.bulkEdit.friday': 'Fredag',
  'aet.bulkEdit.saturday': 'Lørdag',
  'aet.bulkEdit.sunday': 'Søndag',
  'aet.toast.assignmentCreated.title': 'Oppgave opprettet!',
  'aet.toast.assignmentCreated.single': 'Den fikk navnet {assignmentTitle} automatisk',
  'aet.toast.assignmentCreated.multiple': '{count} oppgaver er opprettet',
  'aet.toast.assignmentUpdated.title': 'Oppdateringen lyktes.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} er oppdatert',
  'aet.toast.assignmentUpdated.multiple': '{count} oppgaver er oppdatert',
  'aet.toast.viewAssignment': 'Vis oppgave',
  'aet.toast.viewAssignments': 'Se oppgaver',
  'aet.welcome.title': 'Pearson eLæreboken din er koblet til kurset på læreplattformen',
  'aet.welcome.LMSAccounTitle': 'Utforsk innsikt',
  'aet.welcome.LMSAccounDescription': 'Se hvilke emner klassen din sliter med.',
  'aet.welcome.createAssignmentsTitle': 'Lag oppgaver',
  'aet.welcome.createAssignmentsDescription': 'Tildel kapitler manuelt eller ved å laste opp leselisten din.',
  'aet.welcome.progressViewTitle': 'Følg med på prestasjoner i læreplattformen',
  'aet.welcome.progressViewDescription': 'Velg innstillinger for karaktersynkronisering i læreplattformskurset.',
  'aet.assignmentDetails.noAssignmentFound': 'Fant ingen oppgaver',
  'aet.assignments.loadingErrorTitle': 'Oppgaven kan ikke lastes inn akkurat nå',
  'aet.assignments.loadingErrorDescription': 'Prøv å oppdatere siden, eller sjekk igjen senere.',
  'aet.assignmentStudentDetails.noDataFound': 'Ingen data ennå',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Ingen studenter er registrert',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studentene blir med i klassen din når de kjøper eLæreboken.',
  'aet.home.editAssignmentTooltipDisabled': 'Kan ikke redigere: studentarbeid pågår',
  'aet.home.deleteAssignmentTooltipDisabled': 'Kan ikke slette: studentarbeid pågår',
  'aet.home.StudentDetails.questions': 'Spørsmål',
  'aet.home.StudentDetails.attempts': 'Forsøk',
  'aet.home.StudentDetails.comprehension': 'Selvsikkerhet',
  'hero.titleInfo.tooltip': 'Tittelinformasjon',
  'aet.home.publishAssignments': 'Publiser alle oppgaver',
  'aet.dashboard.footer': 'Noe innhold ble laget med KI basert på Pearsons læremateriell. Selv om Pearson har en prosess for å kvalitetssjekke det som genereres, kan generativ KI fortsatt komme med dårlig informasjon om folk, steder og fakta.',
  'aet.home.bulkEditTitle': 'Redigere flere oppgaver samtidig',
  'aet.home.bulkEditSubtitle': 'Gjør endringene i leselisten og last den opp igjen her. Oppgaver og innleveringstider oppdateres etter endringene.',
  'aet.home.createAssignmentTitle': 'Lag oppgaver',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Inkludert i en annen oppgave',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Noen deler er inkludert i en annen oppgave',
  'aet.welcome.welcome.Title': 'Velkommen!',
  'aet.home.student.roaster.ProgressTitle': 'Samlet fremgang',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Sjekk igjen når studentene starter på oppgaven.',
  'aet.home.whatDueThisWeekTitle': 'Her er det som har frist neste uke',
  'aet.assignments.edit.errorTitle': '{count} oppgaver har feil',
  'aet.assignments.edit.errorSubTitle': 'Oppgaver med feil kan ikke publiseres. Rediger dem eller publiser uten dem.',
  'aet.assignments.edit.publishAnyway': 'Publiser likevel',
  'aet.assignments.edit.editAssignments': 'Rediger oppgaver',
  'aet.assignments.edit.validationInfoToolTip': 'Rediger oppgave for å fjerne feil',
  'aet.assignments.error.assignmentCreated.title': 'Alle oppgavene har feil',
  'aet.assignments.error.assignmentCreated.description': 'Oppgaver med feil kan ikke publiseres. Rediger dem eller prøv en annen leseliste.',
  'aet.assignments.error.uploadSyllabus': 'Last opp leseliste',
  'aet.assignments.error.editAssignments': 'Rediger oppgaver',
  'aet.mondly.title': 'Språk',
  'aet.studentRoster.errorState.title': 'Studentlisten er utilgjengelig',
  'aet.studentRoster.errorState.description': 'Kunne ikke laste inn studentlisten din. Prøv å oppdatere eller sjekke igjen senere.',
  'aet.assignments.sectionLabel': 'del(er)',
  'aet.assignments.questionsLabel': 'spørsmål',
  'aet.assignments.assignmentsLabel': 'oppgave(r)',
  'aet.assignments.performanceProgressBar': 'Fremdriftsviser for resultater',
  'aet.assignments.completionProgressBar': 'Fremdriftsviser for fullførelse',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Er du sikker på at du vil slette denne oppgaven?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Er du sikker på at du vil slette disse oppgavene?',
  'aet.home.nextAssignmentTitle': 'Neste oppgave',
  'aet.home.courseSettings': 'Kursinnstillinger',
  'aet.home.pearsonETextbookResources': 'Pearson+ eLærebok-ressurser',
  'aet.home.etextbookInformation': 'eLærebok-informasjon',
  'aet.multiple.deleteAssignmentKeepCTA': 'Behold oppgave(r)',
  'aet.syllabus.processingText.header': 'Vi organiserer leseleksene til klassen din – dette tar bare et øyeblikk.',
  'aet.syllabus.processingText.uploading': 'Laster opp dokumentet ditt',
  'aet.syllabus.processingText.activating': 'Aktiverer KI-komponenter',
  'aet.syllabus.processingText.extracting': 'Henter leselekser',
  'aet.syllabus.processingText.mapping': 'Tilordner til innhold i læreboken',
  'aet.syllabus.processingText.finishing': 'Ferdigstiller',
  'aet.syllabus.uploadErrorMessage': 'Pass på at PDF- eller .docx-filen er mindre enn 10MB og at internettforbindelsen er stabil',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Prøv igjen',
  'aet.syllabus.selectChapterWithQuestions': 'Velg et kapittel med spørsmål.',
  'preferenceSetting.subTitle': 'Disse innstillingene gjøres til standard for alle elevene i dette kurset.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'KI-samhandling',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Aktiver KI-studieverktøy og KI-oppsummeringer i søkeresultatene',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Vis ressurser for studieforberedelser relatert til denne boken',
  'aet.syllabus.footer': 'Oppgaveopprettelse drives av KI',
  'aet.dashboard.footerDialogDeatils': 'Generativ KI brukes til å opprette oppgaver basert på læremateriell i Pearson. Selv om Pearson har en prosess for å bekrefte KI-utdata, kan KI likevel komme med unøyaktig informasjon om personer, steder eller fakta. KI brukes også til å fordele innhold i oppgaver, basert på leselisten og/eller planen du oppgir.',
  'aet.review.footer': 'Laget med KI',
  'aet.footerCard.dismiss': 'Ignorer',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Studieforberedelser er et verktøy som bidrar til læring ved å gi studenter tilgang til videoer og øvingsproblemer som er tilpasset faget deres.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenter med en tilgangsplan som ikke inkluderer studieforberedelser kan bli bedt om å abonnere for å fortsette å bruke studieforberedelsesressurser.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Studenter som allerede har kjøpt studieforberedelser, blir ikke påvirket av disse innstillingene.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Finn ut mer om fordelene med Studieforberedelser',
  'aet.home.viewCourseId': 'Se fag-ID',
  'aet.home.copy': 'Kopier',
  'aet.home.copied': 'Kopiert',
  'aet.home.courseLabel': 'Fag-ID:',
  'schoolInfoCard.addUniversity': 'Legg til skole',
  'schoolInfoCard.title': 'Skoleinformasjon',
  'schoolInfoCard.titleV1': 'Fortell oss om kurset ditt',
  'schoolInfoCard.cta': 'Kom i gang',
  'schoolInfoCard.pickInstitution': 'Velg skole',
  'schoolInfoCard.addUniversityTitle': 'Legg til skolen din',
  'schoolInfoCard.addUniversitySubtitle': 'Når vi vet skolen og fagene dine, kan vi anbefale det beste læremateriellet for deg.',
  'schoolInfoCard.searchPlaceholder': 'Søk etter skolen din …',
  'schoolInfoCard.skip': 'Hopp over dette trinnet',
  'schoolInfoCard.nextStep': 'Neste trinn',
  'schoolInfoCard.notInList': 'Skolen min er ikke på listen',
  'schoolInfoCard.noResults': 'Fant ingen skoler som matcher søket ditt',
  'schoolInfoCard.noResultsHeading': 'Finner du ikke skolen din?',
  'schoolInfoCard.noResultsInstruction': 'Skriv inn fullt navn nedenfor',
  'schoolInfoCard.noResultsInputPlaceholder': 'Skolens navn',
  'schoolInfoCard.addInstitutionLabel': 'Legg til denne skolen',
  'aet.assignments.assignmentTitlePlaceholder': 'Angi en tittel',
  'aet.assignments.titleValidation.titleRequired': 'Oppgavetittel kreves.',
  'aet.assignments.titleValidation.titleTooLong': 'Oppgavetittelen kan ikke overskride {0} tegn.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Oppgavetittelen inneholder tegn som ikke støttes.',
  'aet.assignments.titleValidation.titleDuplicate': 'Oppgavetittelen finnes allerede',
  'aet.syllabus.timeZoneLabel': 'Tidssone',
  'aet.review.reviewReadingFromAssignments': 'Gå gjennom leselekser fra oppgave',
  'aet.assignments.chaptersLabel': 'kapitler',
  'menu.myAccount.subTitle': 'Insitusjonen din bor her',
  'menu.myAccount.subTitleNotAvailable': 'Du kan legge til institusjonen din her senere.',
  'schoolInfoCard.toastMessage': 'Universitetet ble lagret',
  'aet.review.threeDotMenu.askAI': 'Spør KI',
  'aet.home.suggestedRemediationSubtitle': 'Se relevante videoer og øv for å mestre emnene i faget.',
  'aet.home.laggedQuestionLabel': 'Flaggede spørsmål',
  'aet.home.correctAnswer': 'Riktig svar',
  'aet.home.incorrectAnswer': 'Vanligste gale svar',
  'aet.home.behaviourTrendsLabel': 'Spørsmålsinnsikt',
  'aet.home.strugglingStudentsLabel': 'Studenter som sliter',
  'aet.home.patternsInStudensAiLabel': 'Mønstre i studentens bruk av KI',
  'aet.home.questionLabel': 'Spørsmål',
  'aet.home.studentAskingSimilarQuestions': 'Studenter som stiller lignende spørsmål',
  'aet.home.assignmentDifficultQuestions': 'Vanskelige spørsmål',
  'aet.home.behaviorTrends': 'Spørsmålsinnsikt',
  'aet.home.behaviors': 'Ytelsesindikatorer',
  'aet.home.mostDifficultTopics': 'Vanskeligste spørsmål',
  'aet.home.commentsFromStudentLabel': 'Kommentarer fra studentene',
  'aet.home.disregard': 'Ignorer',
  'aet.home.reportAsInaccurate': 'Rapporter som unøyaktige',
  'aet.home.Flagged': 'Flagget',
  'aet.home.reportQuestionTitle': 'Rapporter spørsmål',
  'aet.home.reportQuestionLabel': 'Hva var galt med dette spørsmålet?',
  'aet.home.showComments': 'Vis kommentarer',
  'aet.home.studentReports': 'studentrapporter',
  'aet.home.placeholderText': 'Vennligst forklar …',
  'aet.home.reportQuestion.notRelevant': 'Ikke relevant',
  'aet.home.reportQuestion.notCorrect': 'Ikke rett',
  'aet.home.reportQuestion.unsafe': 'Farlig/skadelig',
  'aet.home.reportQuestion.somethingElse': 'Noe annet',
  'aet.home.StudentDetails.assistedByAI': 'Med hjelp fra KI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Ingen studenter sliter akkurat nå',
  'aet.home.strugglingStudents.emptyStateDescription': 'Sjekk igjen senere.',
  'aet.home.overallStatus.excelling': 'Utmerker seg',
  'aet.home.overallStatus.fallingBehind': 'Sliter',
  'aet.home.overallStatus.keepingUp': 'Holder tritt',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Bare vis «Vanskelige spørsmål»',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Bare vis «Studenter som sliter»',
  'aet.home.viewQuestionInAssignment': 'Se spørsmål i oppgave',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Feil på første forsøk',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Mange mislykkede forsøk',
  'aet.home.insightRisk.lowConfidence': 'Lav selvsikkerhet',
  'aet.home.insightRisk.mediumConfidence': 'Middels selvsikkerhet',
  'aet.home.insightRisk.lowEngagement': 'Lavt engasjement',
  'aet.home.insightRisk.countOfStudents': '{count} av {total} studenter',
  'aet.home.insightRisk.na': 'Ikke aktuelt',
  'aet.home.strugglingStudentsHereLabel': 'Studentene sliter her',
  'aet.home.insightRisk.didNotAttempt': 'Forsøkte ikke',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default no;
